import {type PreviewQueryContextValue, PreviewQueryProvider} from '../../contexts/PreviewQueryContext'
import type {SavedViewIssuesRenderer} from '../../types'
import NewViewExperience from '../preview/NewViewExperience'

type RepositoryViewNewPreviewProps = {
  owner: string
  repo: string
  query: string
  previewQueryContextValue: PreviewQueryContextValue
  IssuesRenderer: SavedViewIssuesRenderer
}

export function RepositoryViewNewPreview({
  owner,
  repo,
  query,
  previewQueryContextValue,
  IssuesRenderer,
}: RepositoryViewNewPreviewProps) {
  if (!query) {
    return <NewViewExperience />
  }

  return (
    <PreviewQueryProvider value={previewQueryContextValue}>
      <IssuesRenderer owner={owner} repo={repo} query={query} preheatEnabled={false} />
    </PreviewQueryProvider>
  )
}
